<template>
  <div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <div slot="header">
        <span>
          <el-collapse accordion>
            <el-collapse-item>
              <template slot="title">
                搜索<i class="header-icon el-icon-search"></i>
                <el-checkbox v-model="queryForm.onlyDeleted" @change="handleQuery">
                  只看已删除
                </el-checkbox>
                <el-checkbox v-model="queryForm.onlyNoClicked" @change="handleQuery">
                  只看未爬
                </el-checkbox>
              </template>
              <el-form
                @submit.native.prevent
                :model="queryForm"
                ref="queryForm"
                :inline="true"
                label-width="98px"
                size="mini"
              >
                <el-form-item label="SKU" prop="sku">
                  <el-input
                    v-model.trim="queryForm.sku"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item>
                <el-form-item label="名称" prop="skuTitle">
                  <el-input
                    v-model.trim="queryForm.skuTitle"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item>
                 <el-form-item label="最低价" prop="jdPriceMin">
                  <el-input-number v-model="queryForm.jdPriceMin" :step="1" :controls="true" controls-position="right" @change="handleQuery">
                  </el-input-number>
                </el-form-item>
                <!-- <el-form-item label="折扣(精确)" prop="promov2">
                  <el-input
                    v-model.trim="queryForm.promov2"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item> -->
                <el-form-item label="折扣(包含)" prop="promov2Like">
                  <el-input
                    v-model.trim="queryForm.promov2Like"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item label="满减(精确)" prop="promov3">
                  <el-input
                    v-model.trim="queryForm.promov3"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item> -->
                <el-form-item label="满减(包含)" prop="promov3Like">
                  <el-input
                    v-model.trim="queryForm.promov3Like"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item>
                <el-form-item label="优惠(精确)" prop="preferential">
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content" style="max-width: 300px">
                      {{ queryForm.preferential }}
                    </div>
                    <el-select
                      v-model="queryForm.preferential"
                      clearable
                      filterable
                      @change="handleQuery"
                    >
                      <el-option
                        style="width: 600px"
                        v-for="item in preferentialOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="item"
                          placement="top-start"
                          v-if="item.length >= 10"
                        >
                          <div
                            style="
                              width: 100%;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              display: inline-block;
                            "
                          >
                            {{ item }}
                          </div>
                        </el-tooltip>
                      </el-option>
                    </el-select>
                  </el-tooltip>
                </el-form-item>
                <el-form-item label="优惠(包含)" prop="preferentialLike">
                  <el-input
                    v-model.trim="queryForm.preferentialLike"
                    placeholder=""
                    clearable
                    @keyup.enter.native="handleQuery"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    size="mini"
                    @click="handleQuery"
                    >搜索
                  </el-button>
                  <el-button
                    icon="el-icon-refresh"
                    type="warning"
                    size="mini"
                    @click="resetForm('queryForm')"
                    >重置
                  </el-button>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </span>
      </div>

      <el-row :gutter="20"  v-if="doubleProductTotal > 0" >
        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
            <el-button
              type="success"
              icon="el-icon-bottom"
              size="mini"
              @click="handleExport"
              >导出</el-button
            >
            <el-button
              type="warning"
              icon="el-icon-magic-stick"
              size="mini"
              @click="handleRemoveRepeat"
              >去重</el-button
            >
            <el-button
              :disabled="!queryForm.onlyNoClicked || queryForm.pageSize >= 50"
              type="warning"
              icon="el-icon-key"
              size="mini"
              @click="handleCrawlCurrentPage"
              >爬取本页</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleBatchRemove"
              >批量删除</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="handleRemoveBlankPreferential"
              >删除空白</el-button
            >
          </el-col>

          <el-col :span="14" :offset="0">
            <div>
              <el-pagination
                @size-change="doubleProductSizeChange"
                @current-change="doubleProductCurrentChange"
                :current-page.sync="queryForm.current"
                :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                :page-size="queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="doubleProductTotal"
                background
              >
              </el-pagination>
            </div>
          </el-col>
          <el-col :span="2" :offset="0">
            <el-button round size="mini" type="text" icon="el-icon-refresh" @click="init()"
              >刷新
            </el-button>
          </el-col>
        </el-row>
        <el-table
          v-loading="tableLoading"
          ref="doubleProductTableRef"
          :data="doubleProductList"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          border
          :height="windowHeight - 280"
        >
          <el-table-column align="center" type="selection" width="50"> </el-table-column>
          <el-table-column align="center" type="index" width="50"> </el-table-column>
          <el-table-column
            align="center"
            prop="skuTitle"
            label="商品名称"
            width="180"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                :href="scope.row.skuUrlMobile"
                target="_blank"
              >
              <el-button
                style="padding: 3px 15px"
                type="success"
                round
                plain
                size="mini"
                @click.prevent="copySkuUrlMobile(scope.row.skuUrlMobile)"
              >
                复制
              </el-button>
              <el-divider direction="vertical"></el-divider>
                {{ scope.row.skuTitle }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="sku" label="商品编号" width="150">
            <template slot-scope="scope">
              <el-link
                :disabled="!queryForm.onlyNoClicked"
                type="primary"
                :underline="false"
                :href="scope.row.skuUrl"
                target="_blank"
              >
                {{ scope.row.sku }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="jdPrice"
            label="价格"
            width="80"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="promov2"
            label="折扣优惠"
            width="260"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="promov3"
            label="满减优惠"
            width="260"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="preferential"
            label="优惠"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建日期"
            sortable
            width="180"
          ></el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="90">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.deleted == 0"
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="handleRemove(scope.row.id)"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.deleted == 1"
                type="warning"
                icon="el-icon-refresh-left"
                size="mini"
                @click="handleRestoreDelete(scope.row.id)"
                >恢复</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align: center">
          <el-pagination
            @size-change="doubleProductSizeChange"
            @current-change="doubleProductCurrentChange"
            :current-page.sync="queryForm.current"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            :page-size="queryForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="doubleProductTotal"
            background
          >
          </el-pagination>
        </div>
      </el-row>
    </el-card>

    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="60%">
      <el-form
        :model="editForm"
        ref="editForm"
        :rules="editFormRules"
        label-width="80px"
        :inline="false"
        size="mini"
      >
        <el-form-item label="id" prop="trialActivityId">
          <span>{{ editForm.trialActivityId }}</span>
        </el-form-item>

        <el-form-item label="参数" prop="params">
          <el-input
            type="textarea"
            :rows="16"
            v-model="editForm.params"
            placeholder=""
            :maxlength="-1"
            :show-word-limit="false"
            :autosize="{ minRows: 16, maxRows: 32 }"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateParams">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDoubleProductList,
  removeRepeat,
  exportExcel,
  removeByIds,
  restoreDelete,
  removeBlankPreferential,
  listPreferentialDistinct,
} from "@/api/jdDoubleProduct";
export default {
  data() {
    return {
      btnLoading: false,
      tableLoading: false,
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      preferentialOptions: [],
      queryForm: {
        current: 1,
        pageSize: 50,
        trialPrice: undefined,
        jdPrice: undefined,
        activityStartTimeStr: undefined,
        skuTitle: undefined,
        supplyNum: undefined,
        onlyOne: false,
        sku: undefined,
        trialActivityId: undefined,
        productType: "",
        shopInfo: undefined,
        onlyToday: true,
        orderByActivityDesc: false,
        promov2: undefined,
        promov2Like: undefined,
        promov3: undefined,
        promov3Like: undefined,
        preferential: undefined,
        preferentialLike: undefined,
        onlyDeleted: false,
        onlyNoClicked: false,
        jdPriceMin:undefined
      },
      doubleProductTotal: 0,
      doubleProductList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      editDialogVisible: false,
      editForm: {},
      editFormRules: [],
      previewImgList: [],
      selection: [],
      selectionIds: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {
   /*  setInterval(()=>{
      this.getList();
    }, 5000); */
  },
  methods: {
    init() {
      this.getList();
    },
    getPreferentialOptions() {
      listPreferentialDistinct(this.queryForm.onlyNoClicked)
        .then((res) => {
          this.preferentialOptions = res.data;
        })
        .catch((e) => {
          this.$message.error("获取优惠下拉框出错" + e);
        })
        .finally(() => {});
    },
    copySkuUrlMobile(content) {
      let oInput = document.createElement("input");
      oInput.value = content;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message.success("复制成功!");
    },
    handleCrawlCurrentPage() {
      this.$confirm("确定爬取当前页吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.doubleProductList.forEach((item, index) => {
            // setTimeout(function(){
            window.open(item.skuUrlMobile);
            // }, 1000 * 6 * index);
          });
        })
        .catch(() => {});
    },
    handleRemoveBlankPreferential() {
      removeBlankPreferential()
        .then((res) => {
          this.$message.success("操作成功！");
          this.getList();
        })
        .catch((e) => {})
        .finally(() => {});
    },
    handleRestoreDelete(id) {
      restoreDelete(id)
        .then((res) => {
          console.log(res);
          this.$message.success("操作成功！");
          this.getList();
        })
        .catch()
        .finally();
    },
    handleBatchRemove() {
      if (this.selection.length == 0) {
        this.$message.warning("请先选择需要删除的数据数据！");
        return;
      }
      // this.$confirm("是否确认删除选中的数据？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      removeByIds(this.selectionIds.toString())
        .then((res) => {
          this.$message.success("操作成功！");
          this.getList();
        })
        .catch((e) => {})
        .finally(() => {});
      // })
      // .catch(() => {});
    },
    handleRemove(id) {
      // this.$confirm("确认删除?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      removeByIds(id)
        .then((res) => {
          this.$message.success("操作成功！");
          this.getList();
        })
        .catch((e) => {})
        .finally(() => {});
      // })
      // .catch(() => {});
    },
    updateParams() {
      updateParams(this.editForm)
        .then((res) => {
          this.$message.success("更新成功!");
          this.editDialogVisible = false;
          this.getList();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {});
    },
    openEditDialog(row) {
      this.editForm = row;
      this.editDialogVisible = true;
    },
    getList() {
      this.tableLoading = true;
      this.queryForm.password = this.$route.query.password;
      getDoubleProductList(this.queryForm)
        .then((res) => {
          if(res.data){
            this.doubleProductList = res.data.records;
            this.doubleProductTotal = res.data.total;
            this.getPreferentialOptions();
            this.$nextTick(() => {
              if (
                this.$refs.doubleProductTableRef &&
                this.$refs.doubleProductTableRef.doLayout
              ) {
                this.$refs.doubleProductTableRef.doLayout();
              }
            });
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    handleRemoveRepeat() {
      removeRepeat()
        .then((res) => {
          this.$message.success("操作成功!");
          this.getList();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.clicked === 1) {
        return "success-row";
      } else {
        if(row.flag == 1){
          return "notauto-row";
        } else {
          return "warning-row";
        }
      }
    },
    handleExport() {
      window.location.href = "/api/jd/double/export?password=" + this.$route.query.password;
    },
    handleSelectionChange(val) {
      this.selection = val;
      this.selectionIds = [];
      this.selection.forEach((item) => {
        this.selectionIds.push(item.id);
      });
    },
    handleQuery() {
      this.getList();
      this.scrollTop();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getList();
      this.scrollTop();
    },
    doubleProductSizeChange(size) {
      this.queryForm.pageSize = size;
      this.getList();
      this.scrollTop();
    },
    doubleProductCurrentChange(current) {
      this.queryForm.current = current;
      this.getList();
      this.scrollTop();
    },
    clickSkuImg(row) {
      this.previewImgList.push(row.skuImg);
    },
    //跳到页顶
    scrollTop(selector) {
      let element = (selector && document.querySelector(selector)) || window;
      element.scrollTo(0, 0);
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: rgb(253, 230, 245);
}

.el-table .success-row {
  background: #ebf9ed;
}

.el-table .notauto-row {
  background: #eeebf9;
}
</style>
